import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../Common/Layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import { Toast } from "primereact/toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../utils/dateFormat";
interface PolicyCoverageProps {
  onNext?: (data?: any) => void;
  onPrevious?: () => void;
  workflowData?: any;
  currentStep?: number;
  totalSteps?: number;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  state?: string;
  selectedState?: string;
  loading?: boolean;
}

export default function PolicyCoverage(props: PolicyCoverageProps = {}) {
  const toast = React.useRef<Toast>(null);
  const navigate = useNavigate();
  // UM Stacked Medical Payment options
  const umStackedMedicalPaymentOptions = ["Yes", "No"];
  const [selectedUmStackedMedicalPayment, setSelectedUmStackedMedicalPayment] = useState<string>("");
  // Uninsured PD Deductible options
  const uninsuredPdDeductibleOptions = ["250", "500", "1000", "No Coverage"];
  const uninsuredPdDeductibleOptionsGeorgia = ["None", "250", "500", "1000"];
  const [selectedUninsuredPdDeductible, setSelectedUninsuredPdDeductible] = useState<string>("");
  // Underinsured PD options
  const underinsuredPdOptions = ["25", "50", "100", "No Coverage"];
  const underinsuredPdLimitsSouthCarolina = ["None", "25000", "50000", "100000", "75000 CSL", "100000 CSL", "300000 CSL", "500000 CSL"];
  const [selectedUnderinsuredPd, setSelectedUnderinsuredPd] = useState<string>("");
  // Uninsured PD limits options
  const uninsuredPdLimitsOhio = [
    "None",
    "7000",
    "10000",
    "15000",
    "25000",
    "50000",
    "100000",
    "75000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];
  const uninsuredPdLimitsGeorgia = ["None", "25000", "50000", "100000", "100000 CSL", "300000 CSL", "500000 CSL"];
  const uninsuredPdLimitsTennessee = [
    "None",
    "15000",
    "20000",
    "25000",
    "35000",
    "50000",
    "100000",
    "250000",
    "60000 CSL",
    "65000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];
  const uninsuredPdLimitsSouthCarolina = ["None", "25000", "50000", "100000", "75000 CSL", "100000 CSL", "300000 CSL", "500000 CSL"];
  const uninsuredPdLimitsDefault = ["25", "50", "100", "No Coverage"];

  const [selectedUninsuredPdLimit, setSelectedUninsuredPdLimit] = useState<string>("");
  // Accidental Death limits options
  const accidentalDeathLimitsOhio = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsAlabama = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsGeorgia = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsTennessee = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsSouthCarolina = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsFlorida = ["None", "1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000"];
  const accidentalDeathLimitsDefault = ["1000", "2000", "3000", "4000", "5000", "6000", "7000", "8000", "9000", "10000", "No Coverage"];

  const [selectedAccidentalDeathLimit, setSelectedAccidentalDeathLimit] = useState<string>("");
  // Medical Payment limits options
  const medicalPaymentLimitsOhio = ["None", "500", "1000", "2000", "5000", "10000", "25000", "50000"];
  const medicalPaymentLimitsFlorida = ["None", "500", "1000", "2000", "5000"];
  const medicalPaymentLimitsAlabama = ["None", "500", "1000", "2000", "5000", "10000", "25000"];
  const medicalPaymentLimitsGeorgia = ["None", "500", "1000", "2000", "5000", "10000"];
  const medicalPaymentLimitsTennessee = ["None", "250", "500", "750", "1000", "2000", "2500", "5000", "10000"];
  const medicalPaymentLimitsSouthCarolina = ["None", "500", "1000", "2000", "5000", "10000"];
  const medicalPaymentLimitsDefault = ["500", "1000", "2000", "2500", "5000", "10000", "25000", "50000", "No Coverage"];

  const [selectedMedicalPaymentLimit, setSelectedMedicalPaymentLimit] = useState<string>("");
  // UMBI limits options
  const umbiLimitsOhio = [
    "None",
    "12000/25000",
    "15000/30000",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "75000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];
  const umbiLimitsAlabama = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];
  const umbiLimitsFlorida = [
    "None",
    "10000/20000",
    "15000/30000",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];
  const umbiLimitsGeorgia = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];
  const umbiLimitsTennessee = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "60000 CSL",
    "65000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];
  const umbiLimitsDefault = [
    "25/50",
    "50/100",
    "100/300",
    "250/500",
    "300/300",
    "300/500",
    "500/500",
    "500/1 mil",
    "1 mil/1 mil",
    "75 CSL",
    "100 CSL",
    "300 CSL",
    "500 CSL",
    "No Coverage",
  ];
  const umbiLimitsSouthCarolina = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/300000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "75000 CSL",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const [selectedUmbiLimit, setSelectedUmbiLimit] = useState<string>("");
  // UIMBI limits options
  const uimbiLimitsOhio = [
    "None",
    "12000/25000",
    "15000/30000",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "75000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];
  const uimbiLimitsSouthCarolina = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/300000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "75000 CSL",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];
  const uimbiLimitsDefault = [
    "25/50",
    "50/100",
    "100/300",
    "250/500",
    "300/300",
    "300/500",
    "500/500",
    "500/1 mil",
    "1mil/1 mil",
    "75 CSL",
    "100 CSL",
    "300 CSL",
    "500 CSL",
    "No Coverage",
  ];

  const [selectedUimbiLimit, setSelectedUimbiLimit] = useState<string>("");

  // Bodily Injury limits options
  const bodilyInjuryLimitsDefault = ["10/20", "15/30", "25/50", "50/100", "100/300", "250/500", "500/500", "500/1000", "1000/1000", "No Coverage"];

  const bodilyInjuryLimitsOhio = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "75000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];

  const bodilyInjuryLimitsAlabama = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const bodilyInjuryLimitsFlorida = [
    "None",
    "10000/20000",
    "15000/30000",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const bodilyInjuryLimitsGeorgia = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const bodilyInjuryLimitsTennessee = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "65000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];

  const bodilyInjuryLimitsSouthCarolina = [
    "None",
    "25000/50000",
    "50000/100000",
    "100000/300000",
    "250000/500000",
    "300000/300000",
    "300000/500000",
    "500000/500000",
    "500000/1000000",
    "1000000/1000000",
    "5000000/5000000",
    "75000 CSL",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  // Property Damage limits options
  const propertyDamageLimitsDefault = ["10", "25", "50", "100", "200", "250", "300", "400", "500", "750", "1000"];

  const propertyDamageLimitsOhio = [
    "None",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "75000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];

  const propertyDamageLimitsAlabama = [
    "None",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const propertyDamageLimitsFlorida = [
    "None",
    "10000",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const propertyDamageLimitsGeorgia = [
    "None",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];

  const propertyDamageLimitsTennessee = [
    "None",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "65000 CSL",
    "100000 CSL",
    "200000 CSL",
    "300000 CSL",
    "500000 CSL",
    "1000000 CSL",
  ];

  const propertyDamageLimitsSouthCarolina = [
    "None",
    "25000",
    "50000",
    "100000",
    "250000",
    "300000",
    "500000",
    "1000000",
    "75000 CSL",
    "100000 CSL",
    "300000 CSL",
    "500000 CSL",
  ];
  // Store selected limits in policyData for workflow submission
  const [selectedBodilyInjuryLimit, setSelectedBodilyInjuryLimit] = useState<string>("");
  const [selectedPropertyDamageLimit, setSelectedPropertyDamageLimit] = useState<string>("");
  // PIP Type options
  const pipTypeBase = ["Basic", "Extended"];
  const pipTypeFlorida = ["Basic", "Extended"];
  const pipDedBase = ["0", "250", "500", "1000"];
  const pipDedFlorida = ["0", "250", "500", "1000"];
  const pipDedOptionBase = ["NI", "NTRR"];
  const pipDedOptionFlorida = ["Named Insured", "Named Insured/Resident Relatives"];
  const wageLossExclusionBase = ["Yes", "No"];
  const [selectedPipType, setSelectedPipType] = useState<string>("");
  const [selectedPipDed, setSelectedPipDed] = useState<string>("");
  const [selectedPipDedOption, setSelectedPipDedOption] = useState<string>("");
  const [selectedWageLossExclusion, setSelectedWageLossExclusion] = useState<string>("");

  // State-dependent options logic will be handled inside Content component
  // Uninsured Type options (GA only)
  const uninsuredTypeOptions = ["None", "Reduced", "AddedOn"];
  const [selectedUninsuredType, setSelectedUninsuredType] = useState<string>("");
  // Term state
  const [selectedTerm, setSelectedTerm] = useState<string>("Semi Annual");
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});
  const [configurationLoaded, setConfigurationLoaded] = useState(false);
  const [policyEffectiveDate, setPolicyEffectiveDate] = useState<string>("");
  const [policyExpirationDate, setPolicyExpirationDate] = useState<string>("");
  // Statewise Policy Info fields
  const [paperlessDiscount, setPaperlessDiscount] = useState<string>("");

  useEffect(() => {
    const layoutContent = document.querySelector(".layout-content");
    if (layoutContent) {
      layoutContent.scrollTo({ top: 0, behavior: "auto" });
    }
    window.scrollTo({ top: 0, behavior: "auto" });

    // Initialize default dates on mount if no step4 data
    if (!workflowData?.step4?.policyEffectiveDate) {
      const today = formatDate(new Date());
      setPolicyEffectiveDate(today);
      const expDate = new Date();
      expDate.setMonth(expDate.getMonth() + 6);
      setPolicyExpirationDate(formatDate(expDate));
    }
  }, []);
  const { onNext, onPrevious, workflowData, currentStep, totalSteps, isFirstStep, isLastStep, selectedState, loading } = props;

  // Helper function to get state-specific options for each coverage type
  const getStateSpecificOptions = (coverageType: string, state: string): string[] => {
    switch (coverageType) {
      case "bodilyInjury":
        if (state === "Ohio") return bodilyInjuryLimitsOhio;
        if (state === "Alabama") return bodilyInjuryLimitsAlabama;
        if (state === "Florida") return bodilyInjuryLimitsFlorida;
        if (state === "Georgia") return bodilyInjuryLimitsGeorgia;
        if (state === "Tennessee") return bodilyInjuryLimitsTennessee;
        if (state === "South Carolina") return bodilyInjuryLimitsSouthCarolina;
        return bodilyInjuryLimitsDefault;

      case "propertyDamage":
        if (state === "Ohio") return propertyDamageLimitsOhio;
        if (state === "Alabama") return propertyDamageLimitsAlabama;
        if (state === "Florida") return propertyDamageLimitsFlorida;
        if (state === "Georgia") return propertyDamageLimitsGeorgia;
        if (state === "Tennessee") return propertyDamageLimitsTennessee;
        if (state === "South Carolina") return propertyDamageLimitsSouthCarolina;
        return propertyDamageLimitsDefault;

      case "medicalPayment":
        if (state === "Ohio") return medicalPaymentLimitsOhio;
        if (state === "Alabama") return medicalPaymentLimitsAlabama;
        if (state === "Florida") return medicalPaymentLimitsFlorida;
        if (state === "Georgia") return medicalPaymentLimitsGeorgia;
        if (state === "Tennessee") return medicalPaymentLimitsTennessee;
        if (state === "South Carolina") return medicalPaymentLimitsSouthCarolina;
        return medicalPaymentLimitsDefault;

      case "accidentalDeath":
        if (state === "Ohio") return accidentalDeathLimitsOhio;
        if (state === "Alabama") return accidentalDeathLimitsAlabama;
        if (state === "Florida") return accidentalDeathLimitsFlorida;
        if (state === "Georgia") return accidentalDeathLimitsGeorgia;
        if (state === "Tennessee") return accidentalDeathLimitsTennessee;
        if (state === "South Carolina") return accidentalDeathLimitsSouthCarolina;
        return accidentalDeathLimitsDefault;

      case "umbi":
        if (state === "Ohio") return umbiLimitsOhio;
        if (state === "Alabama") return umbiLimitsAlabama;
        if (state === "Florida") return umbiLimitsFlorida;
        if (state === "Georgia") return umbiLimitsGeorgia;
        if (state === "Tennessee") return umbiLimitsTennessee;
        if (state === "South Carolina") return umbiLimitsSouthCarolina;
        return umbiLimitsDefault;

      case "uimbi":
        if (state === "Ohio") return uimbiLimitsOhio;
        if (state === "South Carolina") return uimbiLimitsSouthCarolina;
        return uimbiLimitsDefault;

      case "uninsuredPd":
        if (state === "Ohio") return uninsuredPdLimitsOhio;
        if (state === "Georgia") return uninsuredPdLimitsGeorgia;
        if (state === "Tennessee") return uninsuredPdLimitsTennessee;
        if (state === "South Carolina") return uninsuredPdLimitsSouthCarolina;
        return uninsuredPdLimitsDefault;

      case "uninsuredPdDeductible":
        if (state === "Georgia") return uninsuredPdDeductibleOptionsGeorgia;
        return uninsuredPdDeductibleOptions;

      case "underinsuredPd":
        if (state === "South Carolina") return underinsuredPdLimitsSouthCarolina;
        return underinsuredPdOptions;

      case "umStackedMedicalPayment":
        return umStackedMedicalPaymentOptions;

      case "pipType":
        const statesWithNoCoverage = ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"];
        if (state === "Florida") return pipTypeFlorida;
        if (statesWithNoCoverage.includes(state)) return [...pipTypeBase, "No Coverage"];
        return pipTypeBase;

      case "pipDed":
        const statesWithNoCoverageDed = ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"];
        if (state === "Florida") return pipDedFlorida;
        if (statesWithNoCoverageDed.includes(state)) return [...pipDedBase, "No Coverage"];
        return pipDedBase;

      case "pipDedOption":
        const statesWithNoCoverageOpt = ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"];
        if (state === "Florida") return pipDedOptionFlorida;
        if (statesWithNoCoverageOpt.includes(state)) return [...pipDedOptionBase, "No Coverage"];
        return pipDedOptionBase;

      case "wageLossExclusion":
        const statesWithNoCoverageWage = ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"];
        if (statesWithNoCoverageWage.includes(state)) return [...wageLossExclusionBase, "No Coverage"];
        return wageLossExclusionBase;

      default:
        return [];
    }
  };

  // Helper function to validate and set value only if it exists in state-specific options
  const validateAndSetValue = (value: string, coverageType: string, state: string, setter: (val: string) => void) => {
    if (!value) return;

    const validOptions = getStateSpecificOptions(coverageType, state);

    // Check if the value exists in the valid options (case-insensitive)
    const normalizedValue = validOptions.find((option) => option.toLowerCase() === value.toLowerCase());

    if (normalizedValue) {
      setter(normalizedValue);
    } else {
    }
  };

  useEffect(() => {
    const hasExistingData = workflowData?.step4?.bodilyInjuryLimit || workflowData?.step4?.propertyDamageLimit;

    // Call API when selectedState is available and configuration hasn't been loaded
    if (selectedState && !configurationLoaded && !hasExistingData) {
      getPolicyInformationConfigurationDetails();
    }
  }, [selectedState, configurationLoaded]);

  useEffect(() => {
    if (workflowData?.step4) {
      const step4Data = workflowData.step4;
      const currentState = workflowData?.step1?.state || "";

      // Set policy dates and term
      if (step4Data.term) setSelectedTerm(step4Data.term);
      if (step4Data.policyEffectiveDate) setPolicyEffectiveDate(step4Data.policyEffectiveDate);
      if (step4Data.policyExpirationDate) setPolicyExpirationDate(step4Data.policyExpirationDate);
      if (step4Data.paperlessDiscount) setPaperlessDiscount(step4Data.paperlessDiscount);

      // Set all coverage limits with validation
      validateAndSetValue(step4Data.bodilyInjuryLimit, "bodilyInjury", currentState, setSelectedBodilyInjuryLimit);
      validateAndSetValue(step4Data.propertyDamageLimit, "propertyDamage", currentState, setSelectedPropertyDamageLimit);
      validateAndSetValue(step4Data.pipType, "pipType", currentState, setSelectedPipType);
      validateAndSetValue(step4Data.pipDed, "pipDed", currentState, setSelectedPipDed);
      validateAndSetValue(step4Data.pipDedOption, "pipDedOption", currentState, setSelectedPipDedOption);
      validateAndSetValue(step4Data.wageLossExclusion, "wageLossExclusion", currentState, setSelectedWageLossExclusion);
      if (step4Data.uninsuredType) setSelectedUninsuredType(step4Data.uninsuredType);
      validateAndSetValue(step4Data.umbiLimit, "umbi", currentState, setSelectedUmbiLimit);
      validateAndSetValue(step4Data.uimbiLimit, "uimbi", currentState, setSelectedUimbiLimit);
      validateAndSetValue(step4Data.uninsuredPdLimit, "uninsuredPd", currentState, setSelectedUninsuredPdLimit);
      validateAndSetValue(step4Data.underinsuredPd, "underinsuredPd", currentState, setSelectedUnderinsuredPd);
      validateAndSetValue(step4Data.uninsuredPdDeductible, "uninsuredPdDeductible", currentState, setSelectedUninsuredPdDeductible);
      validateAndSetValue(step4Data.umStackedMedicalPayment, "umStackedMedicalPayment", currentState, setSelectedUmStackedMedicalPayment);
      validateAndSetValue(step4Data.medicalPaymentLimit, "medicalPayment", currentState, setSelectedMedicalPaymentLimit);
      validateAndSetValue(step4Data.accidentalDeathLimit, "accidentalDeath", currentState, setSelectedAccidentalDeathLimit);
    }
  }, [workflowData?.step4]);

  const getPolicyInformationConfigurationDetails = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/policyinformationconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        const config = response.data;

        // Normalize term value - map configuration values to form values
        if (config.term) {
          const termMapping: Record<string, string> = {
            "6 month": "Semi Annual",
            "12 month": "Annual",
            "1 month": "Month",
            "2 month": "Two Month",
            "3 month": "Three Month",
          };
          const termValue = termMapping[config.term.toLowerCase()] || config.term || "Semi Annual";
          setSelectedTerm(termValue);
        }
        // Set default selections based on configuration with validation
        const currentState = workflowData?.step1?.state || selectedState || "";

        validateAndSetValue(config.bodilyInjury, "bodilyInjury", currentState, setSelectedBodilyInjuryLimit);
        validateAndSetValue(config.propertyDamage, "propertyDamage", currentState, setSelectedPropertyDamageLimit);
        validateAndSetValue(config.pipType, "pipType", currentState, setSelectedPipType);
        validateAndSetValue(config.pipDed, "pipDed", currentState, setSelectedPipDed);
        validateAndSetValue(config.pipDedOption, "pipDedOption", currentState, setSelectedPipDedOption);
        validateAndSetValue(config.wageLossExclusion, "wageLossExclusion", currentState, setSelectedWageLossExclusion);
        if (config.uninsuredType) setSelectedUninsuredType(config.uninsuredType);
        validateAndSetValue(config.uninsuredBI, "umbi", currentState, setSelectedUmbiLimit);
        validateAndSetValue(config.underinsuredBI, "uimbi", currentState, setSelectedUimbiLimit);
        validateAndSetValue(config.uninsuredPD, "uninsuredPd", currentState, setSelectedUninsuredPdLimit);
        validateAndSetValue(config.underinsuredPD, "underinsuredPd", currentState, setSelectedUnderinsuredPd);
        validateAndSetValue(config.uninsuredPDDed, "uninsuredPdDeductible", currentState, setSelectedUninsuredPdDeductible);
        validateAndSetValue(config.uM_Stacked, "umStackedMedicalPayment", currentState, setSelectedUmStackedMedicalPayment);
        validateAndSetValue(config.medicalPayments, "medicalPayment", currentState, setSelectedMedicalPaymentLimit);
        validateAndSetValue(config.accidentalDeath, "accidentalDeath", currentState, setSelectedAccidentalDeathLimit);
        setPaperlessDiscount(config.paperlessDiscount || "");
        setConfigurationLoaded(true);
      })
      .catch((error: any) => {
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the policy information configuration details!",
            life: 3000,
          });
        }
      });
  };
  const Content = () => {
    // State-dependent options for PIP and Wage Loss Exclusion
    const statesWithNoCoverage = ["Alabama", "Georgia", "Ohio", "South Carolina", "Tennessee"];
    let pipTypeOptions = pipTypeBase;
    let pipDedOptions = pipDedBase;
    let pipDedOptionOptions = pipDedOptionBase;
    let wageLossExclusionOptions = wageLossExclusionBase;
    let selectedStateName = "";

    // Only run this logic after workflowData is available inside Content
    let umbiOptions = umbiLimitsDefault;
    let uimbiOptions = uimbiLimitsDefault;
    let uninsuredPdOptions = uninsuredPdLimitsDefault;
    let underinsuredPdOpts = underinsuredPdOptions;
    let uninsuredPdDeductibleOpts = uninsuredPdDeductibleOptions;
    let medicalPaymentOptions = medicalPaymentLimitsDefault;
    let accidentalDeathOptions = accidentalDeathLimitsDefault;
    let bodilyInjuryOptions = bodilyInjuryLimitsDefault;
    let propertyDamageOptions = propertyDamageLimitsDefault;
    if (typeof workflowData !== "undefined" && workflowData?.step1?.state) {
      selectedStateName = workflowData.step1.state.toString();
      if (statesWithNoCoverage.includes(selectedStateName)) {
        pipTypeOptions = [...pipTypeBase, "No Coverage"];
        pipDedOptions = [...pipDedBase, "No Coverage"];
        pipDedOptionOptions = [...pipDedOptionBase, "No Coverage"];
        wageLossExclusionOptions = [...wageLossExclusionBase, "No Coverage"];
      }
      if (selectedStateName === "Florida") {
        pipTypeOptions = pipTypeFlorida;
        pipDedOptions = pipDedFlorida;
        pipDedOptionOptions = pipDedOptionFlorida;
        umbiOptions = umbiLimitsFlorida;
        medicalPaymentOptions = medicalPaymentLimitsFlorida;
        bodilyInjuryOptions = bodilyInjuryLimitsFlorida;
        propertyDamageOptions = propertyDamageLimitsFlorida;
        accidentalDeathOptions = accidentalDeathLimitsFlorida;
      }
      if (selectedStateName === "Ohio") {
        umbiOptions = umbiLimitsOhio;
        uimbiOptions = uimbiLimitsOhio;
        uninsuredPdOptions = uninsuredPdLimitsOhio;
        medicalPaymentOptions = medicalPaymentLimitsOhio;
        accidentalDeathOptions = accidentalDeathLimitsOhio;
        bodilyInjuryOptions = bodilyInjuryLimitsOhio;
        propertyDamageOptions = propertyDamageLimitsOhio;
      }
      if (selectedStateName === "Alabama") {
        umbiOptions = umbiLimitsAlabama;
        medicalPaymentOptions = medicalPaymentLimitsAlabama;
        accidentalDeathOptions = accidentalDeathLimitsAlabama;
        bodilyInjuryOptions = bodilyInjuryLimitsAlabama;
        propertyDamageOptions = propertyDamageLimitsAlabama;
      }
      if (selectedStateName === "Georgia") {
        umbiOptions = umbiLimitsGeorgia;
        uninsuredPdOptions = uninsuredPdLimitsGeorgia;
        uninsuredPdDeductibleOpts = uninsuredPdDeductibleOptionsGeorgia;
        medicalPaymentOptions = medicalPaymentLimitsGeorgia;
        accidentalDeathOptions = accidentalDeathLimitsGeorgia;
        bodilyInjuryOptions = bodilyInjuryLimitsGeorgia;
        propertyDamageOptions = propertyDamageLimitsGeorgia;
      }
      if (selectedStateName === "Tennessee") {
        umbiOptions = umbiLimitsTennessee;
        uninsuredPdOptions = uninsuredPdLimitsTennessee;
        medicalPaymentOptions = medicalPaymentLimitsTennessee;
        accidentalDeathOptions = accidentalDeathLimitsTennessee;
        bodilyInjuryOptions = bodilyInjuryLimitsTennessee;
        propertyDamageOptions = propertyDamageLimitsTennessee;
      }
      if (selectedStateName === "South Carolina") {
        umbiOptions = umbiLimitsSouthCarolina;
        uimbiOptions = uimbiLimitsSouthCarolina;
        uninsuredPdOptions = uninsuredPdLimitsSouthCarolina;
        underinsuredPdOpts = underinsuredPdLimitsSouthCarolina;
        medicalPaymentOptions = medicalPaymentLimitsSouthCarolina;
        accidentalDeathOptions = accidentalDeathLimitsSouthCarolina;
        bodilyInjuryOptions = bodilyInjuryLimitsSouthCarolina;
        propertyDamageOptions = propertyDamageLimitsSouthCarolina;
      }
    }
    const calculateExpiration = (effective: string, term: string) => {
      if (!effective) return "";
      const date = new Date(effective);
      if (term === "Annual") {
        date.setMonth(date.getMonth() + 12);
      } else if (term === "Semi Annual") {
        date.setMonth(date.getMonth() + 6);
      } else if (term === "Month") {
        date.setMonth(date.getMonth() + 1);
      } else if (term === "Two Month") {
        date.setMonth(date.getMonth() + 2);
      } else if (term === "Three Month") {
        date.setMonth(date.getMonth() + 3);
      }

      return formatDate(date);
    };

    const stateOptions = [
      { value: "AL", label: "Alabama" },
      { value: "FL", label: "Florida" },
      { value: "GA", label: "Georgia" },
      { value: "OH", label: "Ohio" },
      { value: "SC", label: "South Carolina" },
      { value: "TN", label: "Tennessee" },
    ];
    const allCoverageTypes = [
      { key: "bodilyInjury", label: "Bodily Injury Limits" },
      { key: "propertyDamage", label: "Property Damage Limits" },
      { key: "pip", label: "PIP" },
      { key: "pipDed", label: "PIP Deductible" },
      { key: "pipDedOption", label: "PIP Deductible Option" },
      { key: "wageLossExclusion", label: "Wage Loss Exclusion" },
      // GA only: Uninsured Type
      ...(selectedStateName === "Georgia" ? [{ key: "uninsuredType", label: "Uninsured Type" }] : []),
      { key: "uninsuredBI", label: "Uninsured BI (UMBI)" },
      { key: "underinsuredBI", label: "Underinsured BI (UIMBI)" },
      { key: "uninsuredPD", label: "Uninsured PD" },
      // GA only: Uninsured PD Ded
      ...(selectedStateName === "Georgia" ? [{ key: "uninsuredPDDed", label: "Uninsured PD Ded" }] : []),
      // SC only: Underinsured PD
      ...(selectedStateName === "South Carolina" ? [{ key: "underinsuredPD_SC", label: "Underinsured PD" }] : []),
      { key: "umStackedMedicalPayment", label: "UM Stacked" },
      { key: "medicalPayment", label: "Medical Payment Limits" },
      { key: "accidentalDeath", label: "Accidental Death Limits" },
    ];

    // Map of required coverages by state
    const stateCoverageMap: Record<string, string[]> = {
      Alabama: ["bodilyInjury", "propertyDamage", "uninsuredBI", "medicalPayment", "accidentalDeath"],
      Florida: [
        "bodilyInjury",
        "propertyDamage",
        "pip",
        "pipDed",
        "pipDedOption",
        "wageLossExclusion",
        "uninsuredBI",
        "medicalPayment",
        "accidentalDeath",
        "umStackedMedicalPayment",
      ],
      Georgia: [
        "bodilyInjury",
        "propertyDamage",
        "medicalPayment",
        "accidentalDeath",
        "uninsuredType",
        "uninsuredBI",
        "uninsuredPD",
        "uninsuredPDDed",
      ],
      Ohio: ["bodilyInjury", "propertyDamage", "uninsuredBI", "underinsuredBI", "uninsuredPD", "medicalPayment", "accidentalDeath"],
      "South Carolina": [
        "bodilyInjury",
        "propertyDamage",
        "underinsuredBI",
        "underinsuredPD_SC",
        "uninsuredBI",
        "uninsuredPD",
        "medicalPayment",
        "accidentalDeath",
      ],
      Tennessee: ["bodilyInjury", "propertyDamage", "uninsuredBI", "uninsuredPD", "medicalPayment", "accidentalDeath"],
    };

    // Use state from workflowData.step1.state, fallback to contactInfo.state, then AL
    const selectedState = workflowData?.step1?.state || "";
    // Filter coverages based on selected state

    const coverageTypes = allCoverageTypes.filter((cov) => stateCoverageMap[selectedState]?.includes(cov.key));

    const handleInputChange = (field: string, value: string) => {
      if (field === "term") {
        setSelectedTerm(value);
        const newExpiration = calculateExpiration(policyEffectiveDate, value);
        setPolicyExpirationDate(newExpiration);
      } else if (field === "policyEffectiveDate") {
        setPolicyEffectiveDate(value);
        const newExpiration = calculateExpiration(value, selectedTerm);
        setPolicyExpirationDate(newExpiration);
      } else if (field === "paperlessDiscount") {
        setPaperlessDiscount(value);
      }
    };

    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      // Handle form submission and pass data to workflow
      if (onNext) {
        const policyData = {
          policyEffectiveDate,
          policyExpirationDate,
          term: selectedTerm,
        };
        onNext(policyData);
      }
    };

    const handleClear = () => {
      setPolicyEffectiveDate("");
      setPolicyExpirationDate("");
      setSelectedTerm("Semi Annual");
      setValidationErrors({});
    };

    const validatePolicyCoverage = () => {
      const errors: { [key: string]: string } = {};

      // Validate policy information fields
      if (!policyEffectiveDate) {
        errors.policyEffectiveDate = "Policy Effective Date is required";
      }
      if (!policyExpirationDate) {
        errors.policyExpirationDate = "Policy Expiration Date is required";
      }
      if (!selectedTerm) {
        errors.term = "Term is required";
      }

      // Validate coverage based on selected state
      const selectedState = workflowData?.step1?.state || "";
      const stateCoverageMap: Record<string, string[]> = {
        Alabama: ["bodilyInjury", "propertyDamage", "uninsuredBI", "medicalPayment", "accidentalDeath"],
        Florida: [
          "bodilyInjury",
          "propertyDamage",
          "pip",
          "pipDed",
          "pipDedOption",
          "wageLossExclusion",
          "uninsuredBI",
          "medicalPayment",
          "accidentalDeath",
          "umStackedMedicalPayment",
        ],
        Georgia: [
          "bodilyInjury",
          "propertyDamage",
          "medicalPayment",
          "accidentalDeath",
          "uninsuredType",
          "uninsuredBI",
          "uninsuredPD",
          "uninsuredPDDed",
        ],
        Ohio: ["bodilyInjury", "propertyDamage", "uninsuredBI", "underinsuredBI", "uninsuredPD", "medicalPayment", "accidentalDeath"],
        "South Carolina": [
          "bodilyInjury",
          "propertyDamage",
          "underinsuredBI",
          "underinsuredPD_SC",
          "uninsuredBI",
          "uninsuredPD",
          "medicalPayment",
          "accidentalDeath",
        ],
        Tennessee: ["bodilyInjury", "propertyDamage", "uninsuredBI", "uninsuredPD", "medicalPayment", "accidentalDeath"],
      };

      const requiredCoverages = stateCoverageMap[selectedState] || [];

      // Map coverage keys to their respective state values and labels
      const coverageValidation: Record<string, { value: string; label: string }> = {
        bodilyInjury: { value: selectedBodilyInjuryLimit, label: "Bodily Injury Limits" },
        propertyDamage: { value: selectedPropertyDamageLimit, label: "Property Damage Limits" },
        pip: { value: selectedPipType, label: "PIP" },
        pipDed: { value: selectedPipDed, label: "PIP Deductible" },
        pipDedOption: { value: selectedPipDedOption, label: "PIP Deductible Option" },
        wageLossExclusion: { value: selectedWageLossExclusion, label: "Wage Loss Exclusion" },
        uninsuredBI: { value: selectedUmbiLimit, label: "Uninsured BI (UMBI)" },
        underinsuredBI: { value: selectedUimbiLimit, label: "Underinsured BI (UIMBI)" },
        uninsuredPD: { value: selectedUninsuredPdLimit, label: "Uninsured PD" },
        uninsuredPDDed: { value: selectedUninsuredPdDeductible, label: "Uninsured PD Deductible" },
        underinsuredPD: { value: selectedUnderinsuredPd, label: "Underinsured PD" },
        underinsuredPD_SC: { value: selectedUnderinsuredPd, label: "Underinsured PD" },
        uninsuredType: { value: selectedUninsuredType, label: "Uninsured Type" },
        umStackedMedicalPayment: { value: selectedUmStackedMedicalPayment, label: "UM Stacked" },
        medicalPayment: { value: selectedMedicalPaymentLimit, label: "Medical Payment Limits" },
        accidentalDeath: { value: selectedAccidentalDeathLimit, label: "Accidental Death Limits" },
      };

      requiredCoverages.forEach((coverage) => {
        const coverageData = coverageValidation[coverage];
        if (coverageData && !coverageData.value) {
          errors[coverage] = `${coverageData.label} is required`;
        }
      });

      setValidationErrors(errors);

      if (Object.keys(errors).length > 0) {
        // Show error toast
        toast.current?.show({
          severity: "error",
          summary: "Validation Error",
          detail: "Please fill in all required fields.",
          life: 4000,
        });
        return false;
      }

      return true;
    };

    // const handleAddCoverage = () => {
    // };

    // const handleAddDriver = () => {
    // };

    // const handleAddVehicle = () => {
    // };

    return (
      <div className="page-container">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <h1>Policy Coverage</h1>
              <span className="title-separator">|</span>
              <p>Configure homeowners insurance coverage limits and deductibles</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="vehicle-form">
          <div className="form-container">
            {/* Policy Information */}
            <div className="form-section-header">
              <h3>Policy Information</h3>
            </div>
            <div className="form-grid">
              {/* Term */}
              <div className="form-group">
                <label>
                  Term <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-input compact-select ${validationErrors.term ? "error" : ""}`}
                  value={selectedTerm}
                  onChange={(e) => {
                    handleInputChange("term", e.target.value);
                    setValidationErrors((prev) => ({ ...prev, term: "" }));
                  }}
                >
                  <option value="Month">Month</option>
                  <option value="Two Month">2 Month</option>
                  <option value="Three Month">3 Month</option>
                  <option value="Semi Annual">Semi Annual</option>
                  <option value="Annual">Annual</option>
                </select>
                {validationErrors.term && <span className="error-message">{validationErrors.term}</span>}
              </div>
              {/* Policy Effective Date */}
              <div className="form-group">
                <label>
                  Policy Effective Date <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={policyEffectiveDate ? new Date(policyEffectiveDate) : null}
                  onChange={(date: Date | null) => {
                    const formattedDate = date ? formatDate(date) : "";
                    handleInputChange("policyEffectiveDate", formattedDate);
                    setValidationErrors((prev) => ({ ...prev, policyEffectiveDate: "" }));
                  }}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  className={`form-input ${validationErrors.policyEffectiveDate ? "error" : ""}`}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={10}
                  minDate={new Date()}
                  autoComplete="off"
                />
                {validationErrors.policyEffectiveDate && <span className="error-message">{validationErrors.policyEffectiveDate}</span>}
              </div>
              {/* Policy Expiration Date */}
              <div className="form-group">
                <label>
                  Policy Expiration Date <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={policyExpirationDate ? new Date(policyExpirationDate) : null}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  className={`form-input ${validationErrors.policyExpirationDate ? "error" : ""}`}
                  readOnly
                  disabled
                />
                {validationErrors.policyExpirationDate && <span className="error-message">{validationErrors.policyExpirationDate}</span>}
              </div>
              {/* Statewise fields */}

              <div className="form-group">
                <label>Paperless Discount</label>
                <select
                  className="form-input compact-select"
                  value={paperlessDiscount}
                  onChange={(e) => handleInputChange("paperlessDiscount", e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
          </div>
          <div className="form-section-header">
            <h3>Coverage Information</h3>
          </div>
          <div className="review-content">
            <DataTable value={coverageTypes} className="custom-datatable">
              <Column field="label" header="Coverage Type" />
              <Column
                header="Limits"
                body={(row) => {
                  if (row.key === "uninsuredType") {
                    // Only show for Georgia
                    if (selectedState === "Georgia") {
                      return (
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <select
                              className={`form-input compact-select ${validationErrors.uninsuredType ? "error" : ""}`}
                              value={selectedUninsuredType}
                              onChange={(e) => {
                                setSelectedUninsuredType(e.target.value);
                                setValidationErrors((prev) => ({ ...prev, uninsuredType: "" }));
                              }}
                            >
                              <option value="">Select</option>
                              {uninsuredTypeOptions.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                            <span className="text-danger">*</span>
                          </div>
                          {validationErrors.uninsuredType && <span className="error-message">{validationErrors.uninsuredType}</span>}
                        </div>
                      );
                    }
                    return null;
                  }

                  if (row.key === "bodilyInjury") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.bodilyInjury ? "error" : ""}`}
                            value={selectedBodilyInjuryLimit}
                            onChange={(e) => {
                              setSelectedBodilyInjuryLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, bodilyInjury: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {bodilyInjuryOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.bodilyInjury && <span className="error-message">{validationErrors.bodilyInjury}</span>}
                      </div>
                    );
                  }
                  if (row.key === "propertyDamage") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.propertyDamage ? "error" : ""}`}
                            value={selectedPropertyDamageLimit}
                            onChange={(e) => {
                              setSelectedPropertyDamageLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, propertyDamage: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {propertyDamageOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.propertyDamage && <span className="error-message">{validationErrors.propertyDamage}</span>}
                      </div>
                    );
                  }
                  if (row.key === "pip") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.pip ? "error" : ""}`}
                            value={selectedPipType}
                            onChange={(e) => {
                              setSelectedPipType(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, pip: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {pipTypeOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.pip && <span className="error-message">{validationErrors.pip}</span>}
                      </div>
                    );
                  }
                  if (row.key === "pipDed") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.pipDed ? "error" : ""}`}
                            value={selectedPipDed}
                            onChange={(e) => {
                              setSelectedPipDed(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, pipDed: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {pipDedOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.pipDed && <span className="error-message">{validationErrors.pipDed}</span>}
                      </div>
                    );
                  }
                  if (row.key === "pipDedOption") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.pipDedOption ? "error" : ""}`}
                            value={selectedPipDedOption}
                            onChange={(e) => {
                              setSelectedPipDedOption(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, pipDedOption: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {pipDedOptionOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.pipDedOption && <span className="error-message">{validationErrors.pipDedOption}</span>}
                      </div>
                    );
                  }
                  if (row.key === "wageLossExclusion") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.wageLossExclusion ? "error" : ""}`}
                            value={selectedWageLossExclusion}
                            onChange={(e) => {
                              setSelectedWageLossExclusion(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, wageLossExclusion: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {wageLossExclusionOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.wageLossExclusion && <span className="error-message">{validationErrors.wageLossExclusion}</span>}
                      </div>
                    );
                  }
                  if (row.key === "uninsuredBI") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.uninsuredBI ? "error" : ""}`}
                            value={selectedUmbiLimit}
                            onChange={(e) => {
                              setSelectedUmbiLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, uninsuredBI: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {umbiOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.uninsuredBI && <span className="error-message">{validationErrors.uninsuredBI}</span>}
                      </div>
                    );
                  }
                  if (row.key === "underinsuredBI") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.underinsuredBI ? "error" : ""}`}
                            value={selectedUimbiLimit}
                            onChange={(e) => {
                              setSelectedUimbiLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, underinsuredBI: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {uimbiOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.underinsuredBI && <span className="error-message">{validationErrors.underinsuredBI}</span>}
                      </div>
                    );
                  }
                  if (row.key === "uninsuredPD") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.uninsuredPD ? "error" : ""}`}
                            value={selectedUninsuredPdLimit}
                            onChange={(e) => {
                              setSelectedUninsuredPdLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, uninsuredPD: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {uninsuredPdOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.uninsuredPD && <span className="error-message">{validationErrors.uninsuredPD}</span>}
                      </div>
                    );
                  }

                  if (row.key === "accidentalDeath") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.accidentalDeath ? "error" : ""}`}
                            value={selectedAccidentalDeathLimit}
                            onChange={(e) => {
                              setSelectedAccidentalDeathLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, accidentalDeath: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {accidentalDeathOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.accidentalDeath && <span className="error-message">{validationErrors.accidentalDeath}</span>}
                      </div>
                    );
                  }
                  if (row.key === "medicalPayment") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.medicalPayment ? "error" : ""}`}
                            value={selectedMedicalPaymentLimit}
                            onChange={(e) => {
                              setSelectedMedicalPaymentLimit(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, medicalPayment: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {medicalPaymentOptions.map((limit) => (
                              <option key={limit} value={limit}>
                                {limit}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.medicalPayment && <span className="error-message">{validationErrors.medicalPayment}</span>}
                      </div>
                    );
                  }
                  if (row.key === "umStackedMedicalPayment") {
                    return (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <select
                            className={`form-input compact-select ${validationErrors.umStackedMedicalPayment ? "error" : ""}`}
                            value={selectedUmStackedMedicalPayment}
                            onChange={(e) => {
                              setSelectedUmStackedMedicalPayment(e.target.value);
                              setValidationErrors((prev) => ({ ...prev, umStackedMedicalPayment: "" }));
                            }}
                          >
                            <option value="">Select</option>
                            {umStackedMedicalPaymentOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                          <span className="text-danger">*</span>
                        </div>
                        {validationErrors.umStackedMedicalPayment && (
                          <span className="error-message">{validationErrors.umStackedMedicalPayment}</span>
                        )}
                      </div>
                    );
                  }
                  if (row.key === "uninsuredPDDed") {
                    // Only show for Georgia
                    if (selectedState === "Georgia") {
                      return (
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <select
                              className={`form-input compact-select ${validationErrors.uninsuredPDDed ? "error" : ""}`}
                              value={selectedUninsuredPdDeductible}
                              onChange={(e) => {
                                setSelectedUninsuredPdDeductible(e.target.value);
                                setValidationErrors((prev) => ({ ...prev, uninsuredPDDed: "" }));
                              }}
                            >
                              <option value="">Select</option>
                              {uninsuredPdDeductibleOptionsGeorgia.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                            <span className="text-danger">*</span>
                          </div>
                          {validationErrors.uninsuredPDDed && <span className="error-message">{validationErrors.uninsuredPDDed}</span>}
                        </div>
                      );
                    }
                    return null;
                  }
                  if (row.key === "underinsuredPD_SC") {
                    // Only show for South Carolina
                    if (selectedState === "South Carolina") {
                      return (
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <select
                              className={`form-input compact-select ${validationErrors.underinsuredPD_SC ? "error" : ""}`}
                              value={selectedUnderinsuredPd}
                              onChange={(e) => {
                                setSelectedUnderinsuredPd(e.target.value);
                                setValidationErrors((prev) => ({ ...prev, underinsuredPD_SC: "" }));
                              }}
                            >
                              <option value="">Select</option>
                              {underinsuredPdLimitsSouthCarolina.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                            <span className="text-danger">*</span>
                          </div>
                          {validationErrors.underinsuredPD_SC && <span className="error-message">{validationErrors.underinsuredPD_SC}</span>}
                        </div>
                      );
                    }
                    return null;
                  }
                  return null;
                }}
                style={{ textAlign: "center" }}
              />
            </DataTable>
          </div>
          <div className="form-actions">
            {!isFirstStep && (
              <button className="btn btn-secondary" onClick={onPrevious}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" stroke="currentColor" />
                </svg>
                Previous
              </button>
            )}
            {/* <button type="button" className="btn btn-secondary" onClick={handleClear}>
              Clear Form
            </button> */}
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                if (validatePolicyCoverage()) {
                  const completeData = {
                    policyEffectiveDate,
                    policyExpirationDate,
                    paperlessDiscount,
                    term: selectedTerm,
                    bodilyInjuryLimit: selectedBodilyInjuryLimit,
                    propertyDamageLimit: selectedPropertyDamageLimit,
                    pipType: selectedPipType,
                    pipDed: selectedPipDed,
                    pipDedOption: selectedPipDedOption,
                    wageLossExclusion: selectedWageLossExclusion,
                    uninsuredType: selectedUninsuredType,
                    umbiLimit: selectedUmbiLimit,
                    uimbiLimit: selectedUimbiLimit,
                    accidentalDeathLimit: selectedAccidentalDeathLimit,
                    medicalPaymentLimit: selectedMedicalPaymentLimit,
                    uninsuredPdLimit: selectedUninsuredPdLimit,
                    umStackedMedicalPayment: selectedUmStackedMedicalPayment,
                    uninsuredPdDeductible: selectedUninsuredPdDeductible,
                    underinsuredPd: selectedUnderinsuredPd,
                  };
                  onNext && onNext(completeData);
                }
              }}
            >
              {loading ? (
                "Saving..."
              ) : (
                <>
                  Continue
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" stroke="currentColor" />
                  </svg>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    );
  };

  // Return Content without Layout if being used in a stepper workflow
  if (onNext || currentStep !== undefined) {
    return (
      <>
        <Toast ref={toast} />
        <Content />
      </>
    );
  }

  // Return Content wrapped in Layout for standalone page
  return (
    <Layout currentPage="Policy Coverage">
      <Toast ref={toast} />
      <Content />
    </Layout>
  );
}
